import * as type from 'constants/action_types'

export const initialState = {
  paginate: {
    pageSize: 5,
    from: 0,
    page: 1
  },
  searchIds: [],
  searchResults: {} // e.g. { 'us/B00': asinSearchResultType }
}

function supplierAsin(state = initialState, action) {
  switch (action.type) {
    case type.SET_SUPPLIER_ASIN_DATA: {
      return {
        ...state,
        [action.payload.prop]: action.payload.value
      }
    }
    case type.SET_SUPPLIER_ASIN_RESULT_DATA: {
      const { id } = action.payload
      return {
        ...state,
        searchResults: {
          ...state.searchResults,
          [id]: {
            ...state.searchResults[id],
            ...action.payload
          }
        }
      }
    }
    default:
      return state
  }
}

export default supplierAsin
